import React from 'react';
import { InlineWidget } from 'react-calendly';
import MetaHead from '@/Components/MetaHead';
export default function ContactUs() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <MetaHead />
      <div
        style={{
          padding: '20px',
          height: '100vh',
          backgroundColor: 'white',
        }}
      >
        <InlineWidget
          styles={{
            height: '80vh',
          }}
          url="https://calendly.com/shriyognorlawar/30min"
        />
      </div>
    </div>
  );
}
